import React from 'react';
import { Accent, Box, Text } from '@nerdwallet/currency';
import PropTypes from 'prop-types';
import Image from '@nerdwallet/react-image';
import classNames from 'classnames';

import { linkParser } from '../../../lib/parse-md-links';
import styles from './socialimpact-carousel.module.less';

const SocialImpactCarouselTile = ({
  icon,
  altImage,
  preheader,
  title,
  content,
  wideImage,
}) => (
  <Box className={styles.carouselCardContainer} padding="4" margin="2">
    <Box
      marginBottom="3"
      marginX="auto"
      className={classNames(styles.carouselCardImage, {
        [styles.wideImage]: wideImage,
      })}
    >
      <Image src={icon} alt={altImage} backgroundColor="transparent" lazy />
    </Box>
    <Box display="flex" flexDirection="column" paddingBottom="2">
      <Accent>{preheader}</Accent>
      <Box marginTop="2">
        <Text size="large" bold>
          {title}
        </Text>
      </Box>
    </Box>
    <Box marginBottom="2">{linkParser(content)}</Box>
  </Box>
);

SocialImpactCarouselTile.displayName = 'Diversity Carousel';
SocialImpactCarouselTile.analyticsName = 'diversity_carousel';

SocialImpactCarouselTile.propTypes = {
  icon: PropTypes.string,
  altImage: PropTypes.string,
  preheader: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  wideImage: PropTypes.bool,
};

export default SocialImpactCarouselTile;
